// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2NQLA","clinicsSelect":"TableHeading_clinicsSelect__zgXOE"};